import React, { useState } from "react";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip, useMediaQuery } from "@material-ui/core";
import { MoreHoriz } from "@material-ui/icons";
import OutcomeMenuIcon from "./OutcomeMenuIcon";
import { usePageHeaderMode } from "../../hooks/useTabletPortrait";

// The same actions and handlers are used in both layouts; only their presentation changes.
// Only a phone lacks the room for them side by side, so only a phone groups them in a menu.
export default function TicketQuickActions({ actions, classes = {} }) {
  const touch = useMediaQuery("(pointer: coarse)");
  const compact = usePageHeaderMode() === "phone" && touch;
  const [anchor, setAnchor] = useState(null);
  const closeMenu = event => {
    if (event) event.stopPropagation();
    setAnchor(null);
  };

  if (!compact || actions.length <= 1) {
    return <span style={{ display: "flex", gap: "var(--ticket-action-gap, 3px)" }} onClick={event => event.stopPropagation()}>
      {actions.map(action => {
        const button = <IconButton size="small" className={classes[action.buttonClass] || classes.actionBtn} aria-label={action.ariaLabel || action.label} disabled={action.disabled} onClick={action.onClick}>{action.icon}</IconButton>;
        return <Tooltip key={action.key} title={action.title || action.label}>{action.disabled ? <span>{button}</span> : button}</Tooltip>;
      })}
    </span>;
  }

  return <span onClick={event => event.stopPropagation()}>
    <IconButton
      size="small"
      className={classes.actionBtn}
      aria-label="Ações do atendimento"
      aria-haspopup="menu"
      aria-expanded={Boolean(anchor)}
      onClick={event => { event.stopPropagation(); setAnchor(event.currentTarget); }}
    >
      <MoreHoriz className={classes.icon} />
    </IconButton>
    <Menu
      anchorEl={anchor}
      open={Boolean(anchor)}
      onClose={closeMenu}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      getContentAnchorEl={null}
      PaperProps={{ style: { minWidth: 0, width: "max-content", maxWidth: "calc(100vw - 32px)" } }}
    >
      {actions.map(action => (
        <MenuItem
          key={action.key}
          disabled={action.disabled}
          aria-label={`${action.ariaLabel || action.label}${action.disabled && action.title && action.title !== action.label ? `: ${action.title}` : ""}`}
          title={action.disabled ? action.title : undefined}
          onClick={event => { closeMenu(event); action.onClick(event); }}
        >
          <ListItemIcon style={{ minWidth: 36 }}>{action.key === "won" || action.key === "lost" ? <OutcomeMenuIcon outcome={action.key} /> : action.icon}</ListItemIcon>
          <ListItemText primary={action.label} />
        </MenuItem>
      ))}
    </Menu>
  </span>;
}
